var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderProductBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69531 7.18542L11.6953 11.1855L12.3045 9.8147L3.30451 5.8147L2.69531 7.18542ZM12.7499 21.5001V10.5001H11.2499V21.5001H12.7499ZM12.3045 11.1855L21.3045 7.18542L20.6953 5.8147L11.6953 9.8147L12.3045 11.1855Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.1102V6.88997C3 6.65286 3.13964 6.43799 3.35632 6.34169L11.7563 2.60835C11.9115 2.5394 12.0885 2.5394 12.2437 2.60835L20.6437 6.34169C20.8604 6.43799 21 6.65286 21 6.88997V17.1102C21 17.3473 20.8604 17.5622 20.6437 17.6585L12.2437 21.3918C12.0885 21.4607 11.9115 21.4607 11.7563 21.3918L3.35632 17.6585C3.13964 17.5622 3 17.3473 3 17.1102Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5L16.1437 8.34164C16.3604 8.43794 16.5 8.65281 16.5 8.88992V12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProductBox);
export default __webpack_public_path__ + "static/media/header-product-box.3b48dc34d503ba0fcb2da6c27b71a824.svg";
export { ForwardRef as ReactComponent };